import { onIdTokenChanged } from "firebase/auth";
import { onCleanup } from "solid-js";
import { createStore, reconcile } from "solid-js/store";

export function useAuth(auth) {
  const [state, setState] = createStore({
    loading: auth.currentUser === null,
    data: auth.currentUser,
    error: null,
  });
  onCleanup(
    onIdTokenChanged(
      auth,
      (user) =>
        setState(reconcile({ loading: false, data: user, error: null })),
      (error) => setState(reconcile({ loading: false, data: null, error })),
    ),
  );
  return state;
}
